import { makeAutoObservable, runInAction } from "mobx";
import axios from "axios";
import urls from './Urls';

class ImageStore {
    imagesMap = {};
    cardSize = { width: 200, height: 264 };

    constructor() {
        makeAutoObservable(this);
        this.loadCardSizeFromStorage();
    }

    setCardSize(key, value) {
        this.cardSize[key] = value;
        this.saveCardSizeToStorage();
    }

    saveCardSizeToStorage() {
        localStorage.setItem("cardSize", JSON.stringify(this.cardSize));
    }

    loadCardSizeFromStorage() {
        const stored = localStorage.getItem("cardSize");
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed.width && parsed.height) {
                    this.cardSize = parsed;
                }
            } catch (e) {
                console.error("Failed to parse cardSize from localStorage:", e);
            }
        }
    }

    async getImages() {
        try {
            if (Object.keys(this.imagesMap).length > 0)
                return;

            const response = await axios.get(urls.additionalInfo.getImages, {
                withCredentials: true
            });
            runInAction(() => {
                const map = {};
                for (const item of response.data) {
                    map[item._id] = item.images;
                }
                this.imagesMap = map;
            });
        } catch (error) {
            console.error("Error fetching all images:", error);
        }
    }

    // מביא תמונות לפי _id ומעדכן רק את אותו key במפה
    async updateImages(_id) {
        try {
            const response = await axios.get(`${urls.additionalInfo.getImages}/${_id}`, {
                withCredentials: true
            });
            const updatedItem = response.data?.[0];

            runInAction(() => {
                delete this.imagesMap[_id]; // To force a DOM update
                this.imagesMap[updatedItem._id] = updatedItem.images;
            });
        } catch (error) {
            console.error(`Error updating images for _id ${_id}:`, error);
        }
    }
}

const imageStore = new ImageStore();
export default imageStore;
